//
// Account referral related queries.
//

import gql from 'graphql-tag';

export const AccountRefIdExists = gql`
  query accountRefIdExists($refId: String!) {
    accountRefIdExists(ref_id: $refId) {
      exists
    }
  }
`;

export const AccountPromoCodeVerify = gql`
  query accountPromoCodeVerify(
    $promoCode: String!
    $price: CurrencyInput
    $event_addon_item_ids: [String!]
  ) {
    accountPromoCodeVerify(
      promo_code: $promoCode
      price: $price
      event_addon_item_ids: $event_addon_item_ids
    ) {
      is_valid
      type
      is_eligible
      discount {
        mode
        value
      }
      trial_days
      discounted_price {
        value
        currency
      }
      scope
      album_folder {
        id
      }
    }
  }
`;
export const AccountAffiliateUrlVerify = gql`
  query accountAffiliateUrlVerify($refId: String!) {
    accountAffiliateUrlVerify(ref_id: $refId) {
      is_valid
      type
      is_eligible
    }
  }
`;
